"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChineseAbbrv = exports.PortugueseAbbrv = exports.KoreanAbbrv = exports.JapaneseAbbrv = exports.ItalianAbbrv = exports.FrenchAbbrv = exports.SpanishAbbrv = exports.EnglishAbbrv = exports.GermanAbbrv = exports.Chinese = exports.Portuguese = exports.Korean = exports.Japanese = exports.Italian = exports.French = exports.Spanish = exports.English = exports.German = exports.BrandcenterTypeField = exports.VideoType = exports.TemplateType = exports.LogoType = exports.DocumentType = exports.AudioType = exports.ImageType = exports.RegionTypeFilter = exports.OurCausesTypeFilter = exports.KeywordTypeFilter = exports.CampaignTypeFilter = exports.AssetSubTypeFilter = exports.AssetTypeFilter = exports.RegionTypeGQL = exports.OurCausesTypeGQL = exports.KeywordTypeGQL = exports.CampaignTypeGQL = exports.AssetSubTypeGQL = exports.AssetTypeGQL = exports.RegionTypeId = exports.FacetHeadingId = exports.LanguagesTypeId = exports.OurCausesTypeId = exports.KeywordTypeId = exports.CampaignTypeId = exports.AssetSubTypeId = exports.AssetTypeId = exports.TemplatesTabPrefix = exports.DownloadsTabPrefix = exports.SiteTabKey = exports.TemplatesTabKey = exports.DownloadsTabKey = void 0;
exports.LanguageQueryParam = exports.SearchTermQueryParam = void 0;
exports.DownloadsTabKey = "Downloads";
exports.TemplatesTabKey = "Templates";
exports.SiteTabKey = "Site";
exports.DownloadsTabPrefix = "dt_";
exports.TemplatesTabPrefix = "tt_";
exports.AssetTypeId = "assettype";
exports.AssetSubTypeId = "assetsubtype";
exports.CampaignTypeId = "campaign";
exports.KeywordTypeId = "keyword";
exports.OurCausesTypeId = "ourcauses";
exports.LanguagesTypeId = "languages";
exports.FacetHeadingId = "facetheading";
exports.RegionTypeId = "region";
exports.AssetTypeGQL = "AssetType";
exports.AssetSubTypeGQL = "AssetSubType";
exports.CampaignTypeGQL = "Campaign";
exports.KeywordTypeGQL = "Keyword";
exports.OurCausesTypeGQL = "OurCauses";
exports.RegionTypeGQL = "Region";
exports.AssetTypeFilter = "Asset Type";
exports.AssetSubTypeFilter = "Asset SubType";
exports.CampaignTypeFilter = "Campaign";
exports.KeywordTypeFilter = "Keyword";
exports.OurCausesTypeFilter = "Our Causes";
exports.RegionTypeFilter = "Region";
exports.ImageType = "Image";
exports.AudioType = "Audio";
exports.DocumentType = "Document";
exports.LogoType = "Logo";
exports.TemplateType = "Template";
exports.VideoType = "Video";
exports.BrandcenterTypeField = "BrandcenterType";
exports.German = "German";
exports.English = "English";
exports.Spanish = "Spanish";
exports.French = "French";
exports.Italian = "Italian";
exports.Japanese = "Japanese";
exports.Korean = "Korean";
exports.Portuguese = "Portuguese";
exports.Chinese = "Chinese";
exports.GermanAbbrv = "DE";
exports.EnglishAbbrv = "EN";
exports.SpanishAbbrv = "ES";
exports.FrenchAbbrv = "FR";
exports.ItalianAbbrv = "IT";
exports.JapaneseAbbrv = "JA";
exports.KoreanAbbrv = "KO";
exports.PortugueseAbbrv = "PT";
exports.ChineseAbbrv = "ZH";
exports.SearchTermQueryParam = "q";
exports.LanguageQueryParam = "lang";
//# sourceMappingURL=constants.js.map